/**
 * Proposal Archive — soft-hide from active Proposals tabs without cancel/lost/delete.
 * Orthogonal to cancelledAt (customer void) and pipelineStage lost.
 *
 * Public Link B: when archivedAt is set, customer content access is revoked
 * (no pricing / line items). The same public URL remains stable; clearing
 * archivedAt (future Restore) re-enables the same link without issuing a new URL.
 */

export const PROPOSAL_ARCHIVE_REASONS = [
  { value: "customer_cancelled", label: "Customer cancelled" },
  { value: "no_longer_proceeding", label: "No longer proceeding" },
  { value: "duplicate", label: "Duplicate" },
  { value: "test_proposal", label: "Test proposal" },
  { value: "superseded", label: "Superseded" },
  { value: "other", label: "Other" },
] as const;

export type ProposalArchiveReasonValue = (typeof PROPOSAL_ARCHIVE_REASONS)[number]["value"];

export const PROPOSAL_ARCHIVE_REASON_VALUES = PROPOSAL_ARCHIVE_REASONS.map((r) => r.value);

export function labelForProposalArchiveReason(value: string | null | undefined): string {
  const v = String(value ?? "").trim();
  const hit = PROPOSAL_ARCHIVE_REASONS.find((r) => r.value === v);
  return hit?.label ?? (v || "—");
}

export type ProposalArchiveSource = "portal_ui" | "cleo" | "admin_action";

export function isProposalArchived(row: { archivedAt?: Date | string | null }): boolean {
  return row.archivedAt != null && String(row.archivedAt).trim() !== "";
}

/**
 * Soft revoke of customer proposal content. True when archivedAt is set.
 * Does not delete data; Restore clears archivedAt to re-enable the same URL.
 */
export function isProposalPublicAccessRevoked(row: { archivedAt?: Date | string | null }): boolean {
  return isProposalArchived(row);
}
